// Helpers for naming and saving files returned by the API.
//
// Browsers name a blob: URL opened in a tab by its random UUID and ignore the
// PDF's /Title when you hit the viewer's download button, so to guarantee a
// filename we trigger an explicit <a download="…"> click on the blob.

// Pull a download filename out of a response's Content-Disposition header,
// preferring the RFC 5987 `filename*` (UTF-8, percent-encoded) over the
// plain `filename="..."`. Falls back to `fallback` when absent/unparseable.
export function filenameFromResponse(res, fallback) {
  try {
    const cd = res.headers.get('Content-Disposition') || '';
    const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
    if (star && star[1]) return decodeURIComponent(star[1].trim());
    const plain = cd.match(/filename="?([^";]+)"?/i);
    if (plain && plain[1]) return plain[1].trim();
  } catch { /* ignore */ }
  return fallback;
}

// Force-download a blob under an exact filename (extension included). Uses a
// throwaway object URL revoked shortly after the click.
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Open a blob in a new tab for preview (kept alive long enough to render),
// then also force-download it under `filename` so the saved file is named
// correctly regardless of the browser's blob-tab behaviour.
export function previewAndSaveBlob(blob, filename) {
  const previewUrl = URL.createObjectURL(blob);
  window.open(previewUrl, '_blank');
  // The preview tab holds its own reference; revoke well after it has loaded.
  setTimeout(() => URL.revokeObjectURL(previewUrl), 60000);
  saveBlob(blob, filename);
}
